import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const DataSourcesReducer = CreateGenericReducer(constructs["data-source"]);
